import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CheckmarkGreenSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CheckmarkGreenSmallPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import { mediaCards } from "../../pages/mock-media";
import styles from "./extract-media-modal.module.css";

type ExtractMediaModalProps = {
  fileName: string;
  isOpen: boolean;
  onClose: () => void;
};

const extractedMedia = Array.from({ length: 3 }, (_, index) => ({
  id: `extracted-media-${index}`,
  imageUrl: mediaCards[0]?.imageUrl,
  imageAlt: mediaCards[0]?.imageAlt,
  title: `SE${index} TERRSJÖ/TONSTAD`,
}));

export const ExtractMediaModal = ({
  fileName,
  isOpen,
  onClose,
}: ExtractMediaModalProps) => {
  const { t } = useTranslation();
  const displayedFileName = fileName || "FY26_L4_main_document.pdf";
  const extractedMediaCount = extractedMedia.length;

  return (
    <FixaModal
      className={styles["modal"]}
      data-testid="extract-media-modal-dialog"
      handleCloseBtn={onClose}
      visible={isOpen}
    >
      <FixaPrompt
        className={styles["prompt"]}
        footer={null}
        header={
          <FixaModalHeader
            className={styles["header"]}
            ariaCloseTxt={t("closeActionString")}
            closeBtnClick={onClose}
          />
        }
        title=""
        titleId="extract-media-modal-dialog-title"
      >
        <section className={styles["content"]}>
          <div className={styles["status"]}>
            <span
              aria-label={t("launchMediaExtractingMediaString")}
              className={styles["spinner"]}
              role="status"
            />
            <FixaText
              className={styles["title"]}
              data-testid="extract-media-modal-title"
              tagName="h1"
            >
              {t("launchMediaExtractingMediaFromString")}{" "}
              <strong className={styles["fileName"]}>
                {displayedFileName}
              </strong>
            </FixaText>
          </div>

          <FixaText className={styles["count"]} tagName="p">
            {t("launchMediaExtractedMediaCountString", {
              count: extractedMediaCount,
            })}
          </FixaText>

          <div className={styles["list"]}>
            {extractedMedia.map((item) => (
              <div className={styles["row"]} key={item.id}>
                <FixaImage
                  alt={item.imageAlt}
                  className={styles["thumbnail"]}
                  src={item.imageUrl}
                  fallback={!item.imageUrl}
                />
                <FixaText className={styles["mediaTitle"]}>
                  {item.title}
                </FixaText>
                <span
                  aria-label={t("launchMediaExtractedStatusString")}
                  className={styles["successIconWrapper"]}
                  data-testid="success-icon"
                  role="img"
                >
                  <FixaSSRIcon
                    className={styles["successIcon"]}
                    paths={CheckmarkGreenSmallIconPath}
                  />
                </span>
              </div>
            ))}

            <div className={styles["row"]}>
              <div aria-hidden="true" className={styles["placeholder"]} />
              <span aria-hidden="true" className={styles["smallSpinner"]} />
              <FixaText className={styles["nextMedia"]}>
                {t("launchMediaExtractingNextMediaString")}
              </FixaText>
            </div>
          </div>
        </section>
      </FixaPrompt>
    </FixaModal>
  );
};
